import { render, staticRenderFns } from "./HowToEarn.vue?vue&type=template&id=b5d6aa3e&scoped=true"
import script from "./HowToEarn.vue?vue&type=script&lang=js"
export * from "./HowToEarn.vue?vue&type=script&lang=js"
import style0 from "./HowToEarn.vue?vue&type=style&index=0&id=b5d6aa3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d6aa3e",
  null
  
)

export default component.exports